import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@features/authentication/store/authStore';
import type { PermissionCode } from '@features/shared/constants/permissions';

interface PermissionRouteProps {
  /** Single permission required to access this route */
  permission?: PermissionCode;
  /** Multiple permissions - user needs ANY of these */
  anyOf?: PermissionCode[];
}

/**
 * Route-level guard that redirects to home if the user lacks the required permission(s).
 */
export function PermissionRoute({ permission, anyOf }: PermissionRouteProps) {
  const hasPermission = useAuthStore((s) => s.hasPermission);

  const allowed = permission
    ? hasPermission(permission)
    : anyOf
      ? anyOf.some((p) => hasPermission(p))
      : true;

  if (!allowed) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
